<template>
  <v-dialog v-model="dialog" max-width="800">
    <template v-slot:activator="{ on, attrs }">
      <mf-button outlined label="Selecionar outra configuração" v-on:click.native="on.click" />
    </template>
    <v-card>
      <v-card-title>Selecione uma configuração</v-card-title>
      <v-card-text>
        <paginated-data-table
          v-if="dialog"
          :headers="headers"
          :query="query"
          :query-variables="queryVariables"
          query-name="hotsiteConfigurations"
          query-main-property-name="hotsiteConfigurations"
        >
          <template v-slot:item="{ item }">
            <tr class="cursor-pointer" @click="selectConfiguration(item)">
              <td>
                {{ item.version }}
              </td>
              <td>
                <version-tag :mode="item.mode" :version="item.version" small />
              </td>
              <td>
                {{ item.created_by.login }}
              </td>
              <td>
                {{ item.created_at | formatDate }}
              </td>
            </tr>
          </template>
        </paginated-data-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { LIST_HOTSITE_CONFIGURATIONS_FOR_SLOT } from '@/modules/configuracoes/site-de-cadastramento/graphql'
import { DateTime } from 'luxon'
import { mapState } from 'vuex'

export default {
  name: 'HotsiteConfigurationSelection',
  components: {
    PaginatedDataTable: () => import('@/components/PaginatedDataTable.vue'),
    VersionTag: () => import('@/modules/configuracoes/site-de-cadastramento/views/components/VersionTag.vue'),
  },
  filters: {
    formatDate(date) {
      return DateTime.fromISO(date).toFormat('dd/MM/yyyy HH:mm:ss')
    },
  },
  data: () => ({
    dialog: false,
  }),
  computed: {
    ...mapState('hotsiteConfiguration', ['hotsiteSlot']),
    headers() {
      return [
        { text: 'Versão', value: 'version' },
        { text: 'Modo', value: 'mode' },
        { text: 'Criado por', value: 'created_by.login' },
        { text: 'Criado em', value: 'created_at' },
      ]
    },
    query() {
      return LIST_HOTSITE_CONFIGURATIONS_FOR_SLOT
    },
    queryVariables() {
      return {
        hotsiteSlotId: this.hotsiteSlot?._id,
      }
    },
  },
  methods: {
    async selectConfiguration(configuration) {
      const confirmed = await this.$confirm({
        title: 'Selecionar configuração',
        message: 'Tem certeza que deseja selecionar esta configuração? Isso irá descartar todas as alterações não salvas.',
        confirmText: 'Sim',
        cancelText: 'Cancelar',
        color: 'warning',
      })
        .then(() => true)
        .catch(() => false)
      if (confirmed) {
        this.$emit('select', configuration)
        this.dialog = false
      }
    },
  },
}
</script>
